// Libraries
import React from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";

// Child Components
import { PoiCategory, TagsList } from "../../common/poiDisplayComponents";
import * as utils from "../../common/misc/utils";

// Constants
const baseUrl = process.env.REACT_APP_API_URL;

// Language query string preservation helper
function galleryUrlPathWithLanguage(lang) {
  return lang === "de" ? `/gallery/?` : `/gallery/?lang=${lang}&`;
}

const Cards = ({ pois, lang, onViewClick, queryParams, noSelTC }) => {
  const additionalQueryParamsString = (() => {
    if (queryParams) {
      const filteredQP = utils.selectQueriesExcept(queryParams, [
        "id", // filter out existing id query as we'll introduce our own
        "view", // filter out view query as we have another mechanism for saving the view
      ]);
      return filteredQP.toString();
    } else return "";
  })();

  return (
    <div className="card-deck my-4">
      {pois.map((poi) => (
        <div
          className="card bg-light card-gallery"
          key={poi._id ? poi._id : poi.title_en}
        >
          <div className="embed-responsive embed-responsive-16by9">
            <img
              className="card-img-top img-gallery embed-responsive-item"
              src={`${baseUrl}/pois/${poi._id}/${poi.filename}`}
              alt={poi.title_en}
            />
          </div>

          <div className="card-body">
            <h4 className="card-title title-ellipsis mb-4">
              {lang === "de" ? poi.title_de : poi.title_en}
            </h4>

            <small className="text-muted ">
              <PoiCategory
                category={poi.category}
                lang={lang}
                linkBaseUrl={galleryUrlPathWithLanguage(lang)}
                noSelTC={noSelTC}
              />
            </small>

            <p className="card-text ellipsis mb-3 mt-1">
              {lang === "de" ? poi.description_de : poi.description_en}
            </p>

            <Link
              className="btn btn-sm btn-outline-primary rounded my-2"
              to={
                `?id=${poi._id}` +
                utils.smartPrepend("&", additionalQueryParamsString)
              }
              onClick={() => onViewClick(poi)}
            >
              {lang === "de" ? "Ansehen" : "View More"}
            </Link>
          </div>

          <div className="card-footer d-flex justify-content-between bg-transparent border-top-0">
            <small className="text-muted">
              <i className="fa fa-tag fa-flip-horizontal"></i>{" "}
              <TagsList
                tags={poi.tags}
                lang={lang}
                linkBaseUrl={galleryUrlPathWithLanguage(lang)}
                noSelTC={noSelTC}
              />
            </small>
          </div>
        </div>
      ))}
    </div>
  );
};

// Typechecking
Cards.propTypes = {
  pois: PropTypes.array.isRequired,
  lang: PropTypes.string.isRequired,
  onViewClick: PropTypes.func.isRequired,
};

export default Cards;
